// SpotBidding の CSV 出力で共有するセル整形ヘルパー。
//
// 通常入札 (spotBidCsv) と ブロック入札 (blockBidCsv) が同じエスケープ規則・
// 同じ数式インジェクション対策を使うため、 model 間で重複させずここに集約する。
// ダウンロード副作用 (BOM 付与 / anchor click) は `~/libs/downloadCsv` の責務。

/** カンマ / 改行 / ダブルクォートを含むセルを RFC 4180 準拠でエスケープする。 */
export const csvCell = (value: string): string =>
  /[",\n\r]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value

/**
 * ユーザー自由入力・外部由来テキストの数式インジェクション対策 (CWE-1236)。
 * 先頭 (前置の空白・制御文字は無視) が `= + - @` の値にアポストロフィを前置し、
 * Excel 等がセルを数式として評価するのを防ぐ (`AdminOcctoMaster/tabs/_common/
 * models/csvExport.ts` の escapeCsvCell と同一方針)。 収支など負値を取り得る
 * システム生成の数値列には適用しない (= 表計算での再集計を壊さないため)。
 */
export const neutralizeFormula = (value: string): string =>
  /^[\s\t\r\n]*[=+\-@]/.test(value) ? `'${value}` : value
